export default __webpack_public_path__ + "static/media/logo.afc49b16.svg";